module.exports = __webpack_public_path__ + "img/logo-vertical-white.1d4d3b58.png";